<template>
  <section>
    <z-dialog :show="isVisible" :d-style="'z-index: 1070'" :bd-style="'z-index: 1065'">
      <template #header>
        <div class="row custom-header">
          <div class="col">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <div class="row">
            <div class="col">
              <p>If you wish to not update 'year', select 'blank' option.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">Year</span>
                </div>
                <select v-model="viewYear" class="form-control" @change="isSave = true">
                  <option v-for="item of viewYears" :key="item.id" :value="item.value">{{ item.name }}</option>
                </select>
              </div>
            </div>
            <div class="col"></div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon1" class="input-group-text">Model</span>
                </div>
                <input v-model="viewModel" type="text" class="form-control" placeholder="Model" aria-label="Model" @keyup="isSave = true" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="row custom-footer">
          <div class="col"></div>
          <div class="col-3 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button type="button" class="btn btn-primary" :class="{ 'btn-danger': isSave }" @click="save">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
export default {
  name: 'DialogAdaslinksEdit',
  components: {
    ZDialog
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      viewYear: null,
      viewModel: null,
      isSave: false
    }
  },
  emits: ['input', 'closing', 'save'],
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'adasmakematrix']),
    title() {
      return 'Edit Adas Links Record'
    },
    isVisible() {
      return this.modelValue !== null
    },
    yearStart() {
      let _data = null
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.yearStart
      }
      return _data
    },
    yearEnd() {
      let _data = null
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.yearEnd
      }
      return _data
    },
    viewYears() {
      let _data = [
        {
          id: 0,
          name: null,
          value: null
        }
      ]
      let cnt = 1
      for (let idx = this.yearStart; idx <= this.yearEnd + 3; idx++) {
        _data.push({
          id: cnt,
          name: idx,
          value: idx
        })
        cnt++
      }
      return _data
    }
  },
  methods: {
    init() {
      console.log('Edit Adas Links', this.value)
      this.viewYear = null
      if (this.value) {
        this.viewModel = this.modelValue.model
      }
    },
    close() {
      this.$emit('closing')
    },
    save() {
      let data = {
        year: this.viewYear ? parseInt(this.viewYear) : null,
        model: this.viewModel.trim(),
        checked: this.modelValue.checked
      }
      this.viewYear = null
      this.$emit('save', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-textarea {
  height: 200px;
}
.custom-value-wrapper {
  position: relative;
  top: 35px;
}
.custom-text-only {
  width: 100%;
  height: 300px;
}
</style>
